import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SocialUser } from '@abacritt/angularx-social-login';
import { PromotorService } from '../services/promotor/promotor.service';
import {
  environment,
  redirectUrlHomeCDC,
  redirectUrlSimulatorCDC,
} from './../../environments/environment';
import { MessagingService } from './../services/messaging/messaging.service';
import { ModalMessageComponent } from './../shared/modais/modal-message/modal-message.component';
import { LoginAction } from './login-action.enum';
import { LoginService } from './login.service';
import { LoginStorage } from './login.storage';
import { LoginCredencial } from './model/login-credencial';
import { SelectAgenteResult } from './select-agente/select-agente-result';
import { SelectAgenteResultStatus } from './select-agente/select-agente-result-status';
import { SelectAgenteComponent } from './select-agente/select-agente.component';
import { finalize, take } from 'rxjs/operators';
import * as toastr from 'toastr';
import { ProdutoStorage } from '../shared/select-produto/produto.storage';
import { ChangePasswordRequest } from './model/change-password-request';
import { HttpStatus } from '../omni-rest/http-status';
import { ModalComponent } from '../shared/modais/modal/modal.component';
import { ModalAceleraMaisComponent } from '../shared/components/modal-acelera-mais/modal-acelera-mais.component';
import { CustomModalService } from '../shared/modais/custom-modal/custom-modal.service';
import { LeadsOnlineService } from '../produtos/leads/services/leads.service';
import { OperacoesGeralService } from '../services/geral/operacoes/operacoes.geral.service';
import { ModalEloGroupComponent } from '../shared/components/modal-elo-group/modal-elo-group.component';
import { SelectProdutoService } from '../shared/select-produto/select-produto.service';
import { StorageService } from '../services/storage/storage.service';
import { LoginParamsUtil } from '../login/login-params.util';
import { firstValueFrom } from 'rxjs';
import { PlusModalComponent } from '../shared/modais/plus-modal/plus-modal.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  @ViewChild('selecionarAgente', { static: true })
  selecionarAgente: SelectAgenteComponent;
  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;
  @ViewChild('modalPasswordTips', { static: true })
  modalPasswordTips: ModalComponent;
  @ViewChild('modalAceleraMais', { static: true })
  modalAceleraMais: ModalComponent;
  @ViewChild('environmentMessage', { static: true })
  environmentMessage: ModalMessageComponent;
  @ViewChild('expiredPassword', { static: true })
  expiredPassword: ModalComponent;
  @ViewChild('alertModal', { static: true })
  alertModal: ModalComponent;

  credencial: LoginCredencial = new LoginCredencial();
  changePasswordCredential: ChangePasswordRequest = new ChangePasswordRequest();
  message: string;
  alertModalMessage: string;
  public version = environment.VERSION_APP;
  private action: LoginAction = LoginAction.LOGIN;
  private actionToBackAfterMessage: LoginAction;
  isLoggingIn = false;
  tipoCliente: number;
  redirectToErp = false;
  produtos: any[];
  private readonly AGENTE_TYPE_ID = 8;
  private readonly LOJISTA_TYPE_ID = 7;
  private readonly ACTIVE_CAMPAIGN = 'ACELERA_MAIS_2_0';
  private readonly ELO_GROUP_CAMPAIGN = 'ELO_GROUP';
  private readonly VEICULO = 'VEÍCULOS';
  private resultAvailableCampaigns: { descricao: string; ativo: boolean }[];

  constructor(
    private readonly loginService: LoginService,
    private produtoService: SelectProdutoService,
    private readonly loginStorage: LoginStorage,
    private readonly router: Router,
    private readonly actRoute: ActivatedRoute,
    private readonly messaging: MessagingService,
    private readonly produtoStorage: ProdutoStorage,
    private readonly promotorService: PromotorService,
    private readonly modalService: CustomModalService,
    private readonly storageService: StorageService,
    private readonly leadsOnlineService: LeadsOnlineService,
    private readonly operacoesGeralService: OperacoesGeralService,
    private readonly loginParams: LoginParamsUtil,
  ) {}

  ngOnInit() {
    this.promotorService.clear();
    this.loginStorage.clear();
    this.produtoStorage.clear();
    this.initSelectAgenteSubscribe();
    this.getTipoCliente();
    this.initExpiredPasswordSubscribe();
    this.openWarningEnvironmentMessage();
  }

  openWarningEnvironmentMessage() {
    // ao pesquisar no google estava aparecendo o site de dev, então foi criado um modal para direcionar para o site oficial
    if (
      !environment.production &&
      !environment.homologation &&
      this.environmentMessage
    ) {
      const message = `
        Você está acessando nosso ambiente de testes internos.
        Para acessar o site oficial, clique
        <a href="https://prd-omni-mais-front.omni.com.br/login" target="_blank">aqui</a>.
      `;
      this.environmentMessage.show(message);
    }
  }

  initSelectAgenteSubscribe() {
    this.selecionarAgente.onSelectAgente.subscribe((result) => {
      this.onSelectAgente(result);
      this.openRedirectModal();
    });
  }

  private initExpiredPasswordSubscribe() {
    this.expiredPassword.ok.subscribe(() => {
      this.changePassword();
    });
  }

  isLogin(): boolean {
    return this.action === LoginAction.LOGIN;
  }

  isChangePassword(): boolean {
    return this.action === LoginAction.CHANGE_PASSWORD;
  }

  isRecoveryPassword(): boolean {
    return this.action === LoginAction.RECOVERY_PASSWORD;
  }

  isMessage(): boolean {
    return this.action === LoginAction.MESSAGE;
  }

  back(): void {
    if (this.actionToBackAfterMessage) {
      this.action = this.actionToBackAfterMessage;
      this.actionToBackAfterMessage = null;
    } else {
      this.action = LoginAction.LOGIN;
    }
  }

  recoveryPassword(): void {
    this.credencial.senha = undefined;
    this.action = LoginAction.RECOVERY_PASSWORD;
  }

  changePassword(): void {
    this.changePasswordCredential.login = this.credencial.login;
    this.changePasswordCredential.oldPassword = undefined;
    this.changePasswordCredential.newPassword = undefined;
    this.changePasswordCredential.newPasswordConfirmed = undefined;
    this.action = LoginAction.CHANGE_PASSWORD;
  }

  login(): void {
    if (!this.credencial.login || !this.credencial.senha) {
      toastr.error('Informe Usuário e Senha para realizar o login');
      return;
    }
    this.credencial.login = this.credencial.login.trim();
    this.isLoggingIn = true;
    this.credencial.tokenPush = this.messaging.getTokenPush();
    this.credencial.versaoAplicacao = environment.VERSION_APP;
    this.loginService.login(this.credencial).subscribe(
      (result) => {
        this.handleUser(result);
      },
      (resultError) => {
        this.gerenciarEventosErro(
          resultError.error.statusCode,
          resultError.error.messages
        );
      }
    );
  }

  handleUser(userData) {
    if ('promotor' in userData.usuario || this.checkShopkeeper(userData)) {
      this.loginStorage.register(userData.usuario);
      this.loginStorage.registerDataExpiracao(userData.dataExpiracao);
      this.openModalAceleraMais(userData);
      this.loginParams.setLoginParams();
    } else {
      this.modalMessage.show('Desculpe, você não é um operador :(');
      this.isLoggingIn = false;
    }
  }

  private checkShopkeeper(userData: any) {
    return userData.usuario.tipoUsuarioTO.descricao === 'LOJISTA';
  }

  sendRecoveryPassword(): void {
    if (!this.credencial.login) {
      toastr.error(
        'Informe o Usuário para realizar a recuperação de sua senha',
      );
      return;
    }
    this.loginService
      .recoveryPassword(this.credencial)
      .pipe(
        finalize(() => {
          this.isLoggingIn = false;
        }),
      )
      .subscribe(
        (result) =>
          toastr.success('Uma senha provisória foi enviada para seu e-mail'),
        (error) =>
          toastr.error(
            `Não foi possível atribuir uma nova senha para o usuário informado. Favor informar novamente ou contatar o Suporte Técnico. ${this.getSpanIdError(
              error,
            )}`,
            'Falha ao redefinir senha',
          ),
      );
  }

  sendChangePassword() {
    if (
      !this.changePasswordCredential.login ||
      !this.changePasswordCredential.oldPassword ||
      !this.changePasswordCredential.newPassword ||
      !this.changePasswordCredential.newPasswordConfirmed
    ) {
      toastr.error(
        'Informe todos os dados para realizar a alteração da sua senha',
      );
      return;
    }
    if (
      this.changePasswordCredential.newPassword !==
      this.changePasswordCredential.newPasswordConfirmed
    ) {
      toastr.error('Confirmação de senha inválida');
      return;
    }
    this.loginService.changePassword(this.changePasswordCredential).subscribe({
      next: (result) => {
        if (result.status === 'SUCCESS') {
          toastr.success('Senha alterada com sucesso');
          this.credencial.login = this.changePasswordCredential.login;
          this.action = LoginAction.LOGIN;
        } else {
          toastr.error(result.messages[0]);
        }
      },
      error: (error) => {
        if (error.status === HttpStatus.BAD_REQUEST && error.error.messages) {
          toastr.error(error.error.messages[0]);
        } else {
          toastr.error(
            `Não foi possível alterar a senha para o usuário informado. Favor tentar novamente ou contatar o Suporte Técnico. ${this.getSpanIdError(
              error,
            )}`,
            'Falha ao alterar a senha',
          );
        }
      },
    });
  }

  onKeyup(event) {
    if (event.keyCode !== 13) {
      return;
    }
    if (this.action === LoginAction.LOGIN) {
      this.login();
    }
    if (this.action === LoginAction.RECOVERY_PASSWORD) {
      this.sendRecoveryPassword();
    }
    if (this.action === LoginAction.CHANGE_PASSWORD) {
      this.sendChangePassword();
    }
  }

  selectRouter() {
    this.actRoute.queryParams.subscribe((params) => {
      if ('route' in params) {
        this.router.navigate([`/${params.route}`]);
      } else if (this.promotorService.isOperadorLiberaCessao) {
        this.router.navigate(['/produtos/cdcloja/cessao']);
      } else if (typeof this.loginStorage.redirectRoute === 'string') {
        this.router.navigate([`/${this.loginStorage.redirectRoute}`]);
        this.loginStorage.clearRedirectRoute();
      } else if (this.checkIfHasCDCIntoProducts()) {
        this.redirectToCDCIntoERP();
      } else {
        this.router.navigate(['/ficha']);
      }
    });
  }

  getTipoCliente() {
    this.tipoCliente = this.storageService.getLocal().tipoCliente;
  }

  private async onSelectAgente(result: SelectAgenteResult) {
    switch (result.status) {
      case SelectAgenteResultStatus.SUCCESS:
        await this.getProdutos();
        this.selectRouter();
        break;
      case SelectAgenteResultStatus.ERROR:
        toastr.warning('Falha na Comunicação, verifique sua conexão.');
        this.isLoggingIn = false;
        break;
      default:
        this.isLoggingIn = false;
    }
  }

  private onCloseAceleraMais() {
    this.selecionarAgente.selecionar();
  }

  handleSocialUser(socialUser: SocialUser): void {
    this.credencial = new LoginCredencial();
    this.credencial.socialToken = socialUser.authToken;
    this.credencial.redeSocial = socialUser.provider;
    this.login();
  }

  private getSpanIdError(error: HttpErrorResponse): string {
    if (error.error.omniSpanId) {
      return `(${error.error.omniSpanId} )`;
    }
    return '';
  }

  public showPasswordTips() {
    this.modalPasswordTips.show();
  }

  async shouldShowModalAceleraMais(userData) {
    const aceleraMaisCampaign = await this.verifyAvailableCampaign(
      this.ACTIVE_CAMPAIGN,
    );
    return (await this.verifyUserTypePopUp(userData)) && aceleraMaisCampaign;
  }

  async verifyAvailableCampaign(campaignParam: string) {
    let resultAvalible: { descricao: string; ativo: boolean };
    try {
      resultAvalible = this.resultAvailableCampaigns.find(
        (campaign) => campaign.descricao === campaignParam,
      );
    } catch (error) {
      console.error('Error on getAvailableCampaigns', error);
      return false;
    }

    if (
      !resultAvalible ||
      resultAvalible.descricao !== campaignParam ||
      !resultAvalible.ativo
    ) {
      return false;
    }
    return true;
  }

  async verifyUserTypePopUp(userData) {
    if (userData.usuario.tipoUsuarioTO.id === this.AGENTE_TYPE_ID) {
      return true;
    }

    if (userData.usuario.tipoUsuarioTO.id !== this.LOJISTA_TYPE_ID) {
      return false;
    }

    try {
      const resultOriginadorLeads =
        await this.leadsOnlineService.getOriginadorLeads();
      const resultProduto: { descricao: string }[] =
        await this.operacoesGeralService.tiposProdutosNoAgent().toPromise();
      this.loginStorage.registerTiposProdutos(JSON.stringify(resultProduto));
      if (
        (resultOriginadorLeads && resultOriginadorLeads.originadorLeads) ||
        (resultProduto &&
          resultProduto.some((produto) => produto.descricao === 'MICROCREDITO'))
      ) {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  async shouldShowModalEloGroup(userData) {
    const eloGroupCampaign = await this.verifyAvailableCampaign(
      this.ELO_GROUP_CAMPAIGN,
    );

    return (await this.verifyUserTypePopUp(userData)) && eloGroupCampaign;
  }

  async getAvailableCampaigns() {
    try {
      this.resultAvailableCampaigns = await firstValueFrom(
        this.loginService.getAvailableCampaigns()
      );
    } catch (error) {
      this.resultAvailableCampaigns = [];
    }
  }

  async openRedirectModal() {
    const resultOriginadorLeads =
      await this.leadsOnlineService.getOriginadorLeads();

    const resultProduto: { descricao: string }[] =
      await this.operacoesGeralService.tiposProdutosNoAgent().toPromise();
    this.operacoesGeralService.tiposProdutosNoAgent();

    if (
      resultOriginadorLeads.originadorLeads === false &&
      resultProduto &&
      resultProduto.some((produto) => produto.descricao === this.VEICULO)
    ) {
      this.modalService.show(PlusModalComponent, {
        ignoreBackdropClick: true,
      });
    }
  }

  async openModalAceleraMais(userData) {
    await this.getAvailableCampaigns();
    const shouldShowModalAceleraMais =
      await this.shouldShowModalAceleraMais(userData);
    const shouldShowModalEloGroup =
      await this.shouldShowModalEloGroup(userData);

    if (!shouldShowModalEloGroup) {
      if (!shouldShowModalAceleraMais) {
        this.selecionarAgente.selecionar();
        return;
      }
      const componentRef = this.modalService.show(ModalAceleraMaisComponent, {
        class: 'modal-acelera-mais',
        ignoreBackdropClick: true,
      });
      componentRef.content.onCloseAceleraMais.subscribe(() => {
        this.onCloseAceleraMais();
      });
    } else {
      const componentRefEloGroup = this.modalService.show(
        ModalEloGroupComponent,
        {
          class: 'modal-elo-group',
          ignoreBackdropClick: true,
        },
      );
      componentRefEloGroup.content.onCloseAceleraMais.subscribe(() => {
        if (shouldShowModalAceleraMais) {
          const componentRef = this.modalService.show(
            ModalAceleraMaisComponent,
            {
              class: 'modal-acelera-mais',
              ignoreBackdropClick: true,
            },
          );
          componentRef.content.onCloseAceleraMais.subscribe(() => {
            this.onCloseAceleraMais();
          });
        } else {
          this.onCloseAceleraMais();
        }
      });
    }
  }

  redirectToCDCIntoERP() {
    this.loginService
      .getUserSettings()
      .subscribe((settings: { onlySimulation: boolean }) => {
        if (settings.onlySimulation) {
          window.open(
            `${environment.URL_ERP}/app/login?login=${this.loginStorage.login}&token=${this.loginStorage.token}&redirectPageUrl=${redirectUrlSimulatorCDC}`,
            '_self',
            'noopener'
          );
          return;
        }

        window.open(
          `${environment.URL_ERP}/app/login?login=${this.loginStorage.login}&token=${this.loginStorage.token}&redirectPageUrl=${redirectUrlHomeCDC}`,
          '_self',
          'noopener'
        );
      });
  }

  checkIfHasCDCIntoProducts() {
    return this.produtos.some(
      (produto) => produto.descricao === 'CDC ESTRUTURADO',
    );
  }
  async getProdutos(): Promise<void> {
    try {
      const res = await this.produtoService
        .getProdutos()
        .pipe(take(1))
        .toPromise();
      this.produtos = res;
    } catch (error) {
      console.error('Error fetching produtos:', error);
    }
  }

  gerenciarEventosErro(statusCode: string, messages: string[]): void {
    const eventos: Record<string, () => void> = {
      INVALID_CREDENTIALS_WILL_LOCK: () => this.exibirModalAlerta(messages),
      PASSWORD_EXPIRED: () => this.expiredPassword.show(),
      UPDATE_APP: () => this.exibirModalAlerta(messages),
      WORKING_HOURS_NOT_ALLOWED: () => this.exibirModalAlerta(messages),
    };
    const evento = eventos[statusCode];
    evento ? evento() : this.definirMensagemErroLogin(messages.join('<br>'));
    this.isLoggingIn = false;
  }

  exibirModalAlerta(messages: string[]): void {
    [this.alertModalMessage] = messages;
    this.alertModal.show();
  }

  definirMensagemErroLogin(message: string): void {
    toastr.error(message, 'Falha ao efetuar o login');
  }
}
